import { fetcher } from '@commenda/utils';

import { TCreateBillingBundleParams } from './types';

export const createBillingBundle = async (params: TCreateBillingBundleParams) => {
  const response = await fetcher('commenda-billing/catalog/bundles', {
    method: 'POST',
    body: params,
  });

  return response;
};
